window.addEventListener('load', () => {
    const ghostPortal = document.getElementById('ghost-portal-root');
    if (!ghostPortal) return;
    
    let ghostPortalWrapper = null;
    let ghostPoweredFinder = null;

    const findAndRemoveGhostPowered = () => {
        if (!ghostPortalWrapper?.firstChild?.contentDocument?.body) return;
        
        const ghostPowered = ghostPortalWrapper.firstChild.contentDocument.body.querySelector('.gh-portal-powered');
        if (ghostPowered) {
            ghostPowered.style.display = 'none';
            clearInterval(ghostPoweredFinder);
        }
    };

    const portalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeName === 'DIV') {
                    ghostPortalWrapper = node;
                    if (ghostPoweredFinder) clearInterval(ghostPoweredFinder);
                    ghostPoweredFinder = setInterval(findAndRemoveGhostPowered, 5);
                }
            });
        });         
    });

    portalObserver.observe(ghostPortal, {
        childList: true,
        subtree: true
    });
});